const TENANT = "vistaprint";
const CB_GCP_API_KEY = "O2dfIJycYw2KqSfmicLxI2rILGAN0ALH5daiQApz";
const DISPLAY_NAME = {
  CHATBOT: "Vista Assistant",
  USER: ""
};
const CHAT_BUTTON_TEXT = {
  CHATBOT: "Need help?",
  MIAW_CHAT: "Chat with us"
};
const CHAT_HEADER_TEXT = {
  CHATBOT: "Vista Assistant",
  MIAW_CHAT: "Chat with a specialist"
};

export { CB_GCP_API_KEY, CHAT_BUTTON_TEXT, CHAT_HEADER_TEXT, DISPLAY_NAME, TENANT };
//# sourceMappingURL=src-config-app-config.js.map
